export default "__VITE_ASSET__DdMlU21s__"